export default "__VITE_ASSET__oinc6Cmj__"